export default __webpack_public_path__ + "static/Druid-639328bdf4476552cb6bd29be14b65c5.png";